import React, { useState } from "react";
import Filter from "../../components/ui/Filter";
import { Button } from "../../components/ui/button";
import DateTimePicker from "../../components/ui/date-filter/DateTimePicker";

const AnaltyicsFilter = ({ close, onApply }) => {
  const [formData, setFormData] = useState({
    date: "",
    shift: "",
    consumer_type: "",
  });

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onApply(formData);
  };

  const handleCancel = () => {
    setFormData({ date: "", shift: "", consumer_type: "" });
    close();
  };

  return (
<div className="fixed inset-0 flex items-center justify-center z-50">
  {/* Backdrop */}
  <div
    className="absolute inset-0 bg-black/30"
    onClick={close}
  />

  {/* Modal */}
  <div className="relative bg-white p-4 rounded-lg shadow w-96 z-50 space-y-4">      <Button
        className="float-end text-xl cursor-pointer bg-white hover:bg-transparent border-transparent"
        onClick={close}
      >
        X
      </Button>

      <div className="flex flex-col pt-4">
        <label>Date</label>
        <DateTimePicker
          type="date"
          label="Date"
          className="w-full"
          value={formData.date ? new Date(formData.date) : null}
          onChange={(newValue) =>
            setFormData((prev) => ({
              ...prev,
              date: newValue ? newValue.toISOString().split("T")[0] : "",
            }))
          }
        />
      </div>
      <Filter
        type="select"
        label="Shift"
        name="shift"
        value={formData.shift}
        onChange={handleChange}
        options={[
          { label: "Shift A", value: "A" },
          { label: "Shift B", value: "B" },
          { label: "Shift C", value: "C" },
        ]}
      />

      <Filter
        type="select"
        label="User Type"
        name="consumer_type"
        value={formData.consumer_type}
        onChange={handleChange}
        options={[
          { label: "Employee", value: "Employee" },
          { label: "Visitor", value: "Visitor" },
        ]}
      />

      <div className="flex justify-between gap-4 pt-4">
        <Button variant="outline" onClick={handleCancel} className="px-8">
          Cancel
        </Button>
        <Button onClick={handleSubmit} className="bg-primary text-white px-8">
          Apply{" "}
        </Button>
      </div>
    </div>

    </div>
  
  );
};

export default AnaltyicsFilter;
